module.exports = __webpack_public_path__ + "static/media/Sunset1.b6e4672f.jpeg";